import { ISearchPhotographerProps } from '@/types/common/photographer'
import { reactive } from 'vue'

interface IStates {
  dateVal: string
  prefVal?: string
}

export const useStates = (props: ISearchPhotographerProps): IStates => {
  return reactive<IStates>({
    dateVal: '',
    prefVal: props.prefVal,
  })
}

export const useActions = (props: ISearchPhotographerProps, states: IStates) => {
  /**
   * 検索
   */
  const search = (): void => {
    let url = '/area'
    const params = new URLSearchParams()

    if (states.dateVal) params.append('date', states.dateVal)

    if (states.prefVal) {
      url += `/${states.prefVal}`
      if (props.categoryVal) url += `/${props.categoryVal}`
    } else {
      if (props.categoryVal) params.append('category', props.categoryVal)
    }

    window.location.href = url + (params.toString() ? '?' + params.toString() : '')
  }
  return {
    search: search,
  }
}
